var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c("p", [_vm._v("打印机配置")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.addDevice()
                      }
                    }
                  },
                  [_vm._v("增加打印机")]
                ),
                _vm._v(" "),
                _vm._l(_vm.form.print_devices, function(device, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: device.key,
                      attrs: { prop: "device." + index + ".value" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "25%", float: "left" },
                        attrs: { placeholder: "打印机名称：" },
                        model: {
                          value: device.name,
                          callback: function($$v) {
                            _vm.$set(device, "name", $$v)
                          },
                          expression: "device.name"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "25%", float: "left" },
                        attrs: { placeholder: "IP地址" },
                        model: {
                          value: device.ip,
                          callback: function($$v) {
                            _vm.$set(device, "ip", $$v)
                          },
                          expression: "device.ip"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "25%", float: "left" },
                        attrs: { placeholder: "端口" },
                        model: {
                          value: device.port,
                          callback: function($$v) {
                            _vm.$set(device, "port", $$v)
                          },
                          expression: "device.port"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeDevice(device)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("仓库基本配置")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3647e63b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647e63b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/PrintDevices.vue
// module id = null
// module chunks = 